module.exports = __webpack_public_path__ + "img/breweries_state.5b08e0aa.png";